import { useMemo } from 'react';

import type { AiDisplayImage } from '../graphql/generated';

export const useFilteredOutUneditedOriginalImages = (
  aiDisplayImages: AiDisplayImage[],
): AiDisplayImage[] =>
  useMemo(
    () =>
      aiDisplayImages.filter(
        image =>
          !!image.aiGeneratedImage.edits || image.createdFrom !== 'original',
      ),
    [aiDisplayImages],
  );
